/**
 * 이상한 방 - 결정론 정렬 비교자
 *
 * ## 왜 `localeCompare`가 아닌가
 *
 * `localeCompare`는 실행 환경의 로케일·ICU 버전에 따라 결과가 달라질 수 있다. 이 저장소의 정렬은
 * 전부 **"같은 입력이면 어디서 돌려도 같은 순서"**를 위한 것이다 - 방 생성(`roomGen`)과 변화
 * 생성(`changeGen`)은 시드 결정론의 전제이고, 와이어 변환(`roomCodec`)은 서버와 클라이언트가
 * 같은 방을 같은 바이트열로 펴야 하며, 리빌 순서(`revealOrder`)는 두 리듀서가 같은 스텝 인덱스를
 * 가리켜야 한다. 그래서 코드 포인트 비교(`<` `>`)만 쓴다.
 *
 * ## 왜 한 파일인가
 *
 * `a.id < b.id ? -1 : a.id > b.id ? 1 : 0`이 네 곳에 인라인으로 있었고, 그중 하나는 같음을 `-1`로
 * 접는 변종이었다(Map 키라 같음이 없어 결과는 같았지만, 그 사실은 그 자리에서만 보인다).
 * 한 줄이라는 것은 갈라져도 눈에 안 띈다는 뜻이다 - `core/math.ts`의 `clamp01`과 같은 이유로 모은다.
 * 두 층(`core`·`game`)이 함께 쓰므로 `core/`에 둔다.
 */

/** 코드 포인트 순 비교. `Array.prototype.sort`에 그대로 넘긴다. */
export function compareCodePoint(a: string, b: string): number {
  return a < b ? -1 : a > b ? 1 : 0
}
